import React, { Component } from "react";
import styled from "styled-components";
import classNames from "classnames";
import { CPage } from "@appcues/component-library";
import { NAVBAR_WIDTH_IN_PIXELS } from "components/App/Navbar";
import { NAV_MODES } from "constants/navModes";

const Context = React.createContext();

export const PAGE_TOP_PADDING_IN_PIXELS = 24;

const Navigation = ({ children }) => (
  <Context.Consumer>
    {({ navMode, actions }) => {
      const isOverlay = navMode !== NAV_MODES.NORMAL;
      const isNavOpen = navMode === NAV_MODES.OVERLAY_OPEN;
      const navModeClass = isOverlay ? "overlay-nav" : "nav";
      const overlayNavClass = isNavOpen ? "open" : "closed";

      return (
        <React.Fragment>
          <StyledNavigation
            className={classNames(navModeClass, isOverlay && overlayNavClass)}
          >
            {children}
          </StyledNavigation>
          <StyledOverlay
            onClick={actions.hideOverlayNav}
            className={classNames(overlayNavClass)}
          />
        </React.Fragment>
      );
    }}
  </Context.Consumer>
);

const StyledNavigation = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  height: 100%;
  width: ${NAVBAR_WIDTH_IN_PIXELS}px;

  &.overlay-nav {
    position: absolute;
    left: -${NAVBAR_WIDTH_IN_PIXELS}px;

    background-color: white;
    z-index: 4;
    transition: left 0.2s ease;

    &.open {
      left: 0;
    }
  }
`;

const StyledOverlay = styled.div`
  display: flex;

  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  background-color: #081731;
  z-index: 3;

  transition: opacity 0.2s ease;
  pointer-events: none;
  opacity: 0;

  &.open {
    opacity: 0.85;
    pointer-events: all;
  }
`;

const Page = ({ children }) => (
  <Context.Consumer>
    {({ isFullScreen }) => (
      <CPage
        maxWidth={
          isFullScreen ? "100%" : `calc(100% - ${NAVBAR_WIDTH_IN_PIXELS}px)`
        }
        paddingBottom={100}
      >
        {children}
      </CPage>
    )}
  </Context.Consumer>
);

export default class AppWrapper extends Component {
  componentDidMount() {
    this.setNavModeByRouteProp();
  }

  componentDidUpdate(prevProps) {
    const { useOverlayNav } = this.props;
    if (prevProps.useOverlayNav !== useOverlayNav) {
      this.setNavModeByRouteProp();
    }
  }

  static Navigation = Navigation;

  static Page = Page;

  setNavModeByRouteProp = () => {
    const { navMode, useOverlayNav, actions } = this.props;
    if (useOverlayNav && navMode === NAV_MODES.NORMAL) {
      actions.setOverlayNavMode(NAV_MODES.OVERLAY_CLOSED);
    } else if (!useOverlayNav && navMode !== NAV_MODES.NORMAL) {
      actions.setOverlayNavMode(NAV_MODES.NORMAL);
    }
  };

  render() {
    const { children, isFullScreen, navMode, actions } = this.props;
    // Use classnames instead of styled-components to handle
    // base apc-react-body styles
    return (
      <Context.Provider value={{ isFullScreen, navMode, actions }}>
        <StyledAppWrapper
          className={classNames(
            "apc-react-body",
            isFullScreen && "isFullScreen"
          )}
        >
          {children}
        </StyledAppWrapper>
      </Context.Provider>
    );
  }
}

const StyledAppWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
